import { createApiQuery } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetRequestDetailRequest, UseGetRequestDetailData, UseGetRequestPageRequest, UseGetRequestPageData, UseGetRequestPageByStatusRequest, UseGetRequestPageByStatusData } from "@api/@types/consent-request";

export const useGetRequestDetail = createApiQuery<UseGetRequestDetailData, UseGetRequestDetailRequest>({
  queryKey: (req) => ["getRequestDetail", req?.groupId, req?.requestId],
  queryFn: (req) => apiClientManager.apis.consentRequest.getRequestDetail(req as UseGetRequestDetailRequest),
  extractData: (res) => res.data.data as UseGetRequestDetailData,
  isEnabled: (req) => Boolean(req?.groupId && req?.requestId),
});

export const useGetRequestPage = createApiQuery<UseGetRequestPageData, UseGetRequestPageRequest>({
  queryKey: (req) => ["getRequestPage", req?.groupId, req?.pageable, req?.customerId],
  queryFn: (req) => apiClientManager.apis.consentRequest.getRequestPage(req as UseGetRequestPageRequest),
  extractData: (res) => res.data.data as UseGetRequestPageData,
  isEnabled: (req) => Boolean(req?.groupId && req?.pageable),
});

export const useGetRequestPageByStatus = createApiQuery<UseGetRequestPageByStatusData, UseGetRequestPageByStatusRequest>({
  queryKey: (req) => ["getRequestPageByStatus", req?.groupId, req?.status, req?.pageable, req?.customerId],
  queryFn: (req) => apiClientManager.apis.consentRequest.getRequestPageByStatus(req as UseGetRequestPageByStatusRequest),
  extractData: (res) => res.data.data as UseGetRequestPageByStatusData,
  isEnabled: (req) => Boolean(req?.groupId && req?.status && req?.pageable),
});

export type { UseGetRequestDetailRequest, UseGetRequestDetailData, UseGetRequestPageRequest, UseGetRequestPageData, UseGetRequestPageByStatusRequest, UseGetRequestPageByStatusData } from "@api/@types/consent-request";
